import React from 'react';

import './CounterControl.css';

const counterControl = (props) => (
    <div className="CounterControl btn btn-primary" onClick={props.clicked}>
        {props.label}
    </div>
);

export default counterControl;